import { ScreenFrame, ListTable } from '@/components/Screen';
import { SectionCard } from '@/components/DataList';
import { Icon } from '@/components/icons';
import { admin } from '@/api/endpoints';
import { pickList } from '@/api/client';
import { useAsync } from '@/hooks/useAsync';
import { Button, Empty, ErrorBox, Loading } from '@/components/ui';
import { formatDateTime, str } from '@/utils/format';

export function SecurityAuditScreen() {
  const state = useAsync(
    () => admin.securityAudit(),
    (p) => pickList(p, 'data', 'events', 'items', 'logs'),
  );

  if (state.loading) return <Loading />;
  if (state.error) return <ErrorBox message={state.error} onRetry={state.reload} />;

  const list = state.data ?? [];

  return (
    <ScreenFrame
      mode="admin"
      icon="shield"
      title="الأمان والسجل"
      subtitle="متابعة الإجراءات الإدارية وسجل النشاط."
    >
      <SectionCard
        title="سجل الإدارة"
        subtitle="يعرض الإجراءات المهمة اللازمة للمتابعة فقط."
        icon={<Icon name="orders" size={24} />}
      >
        <div className="action-row">
          <Button type="button" variant="secondary" onClick={() => state.reload()}>
            <Icon name="refresh" size={17} /> تحديث السجل
          </Button>
        </div>

        {list.length === 0 ? (
          <Empty title="لا توجد عمليات" hint="ستظهر الإجراءات الإدارية المهمة هنا." />
        ) : (
          <ListTable
            headers={['العملية', 'المنفّذ', 'النطاق', 'التاريخ']}
            tableClassName="security-log-table"
            className="top-space"
          >
            <tbody>
              {list.map((e, i) => (
                <tr key={str(e.id, String(i))}>
                  <td>
                    <strong>{str(e.event ?? e.action ?? e.type)}</strong>
                  </td>
                  <td>{str(e.actor ?? e.user_name ?? e.user_id)}</td>
                  <td>{str(e.target ?? e.entity_type ?? e.meta)}</td>
                  <td>{formatDateTime(e.created_at)}</td>
                </tr>
              ))}
            </tbody>
          </ListTable>
        )}
      </SectionCard>
    </ScreenFrame>
  );
}
